import {DetailsList, IconButton, SelectionMode} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";

function Notification(props) {
    const [user] = useContext(AuthContext);
    const [notifications, setNotifications] = useState([]);
    const [refresh, setRefresh] = useState(0);
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/notification", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setNotifications(data) })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [refresh, user.token]);

    const _manageSubscription = (item) => {
        if (item.subscribe !== null) {
            fetch(`/api/notification/${item.id}/unsubscribe`, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            })
        } else {
            fetch(`/api/notification/${item.id}/subscribe`, {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            })
        }
        setRefresh(refresh + 1);
    }

    const columns = [
        {
            key: 'channel',
            name: 'Kanał',
            ariaLabel: 'Kanał powiadomień',
            fieldName: 'channel',
            minWidth: 210,
            isRowHeader: true,
            isResizable: true,
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 90,
            maxWidth: 90,
            onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'MailAlert' }} styles={ {'rootChecked': {'color': 'green', 'backgroundColor': 'transparent'}, root: {color: 'red'}}} title='Subskrybuj' checked={item.subscribe !== null} onClick={() => _manageSubscription(item)}/>
            </span>)
        }
    ];

    return (
        <AppContent title={'Powiadomienia'}>
            <DetailsList items={notifications} columns={columns} selectionMode={SelectionMode.none}/>
        </AppContent>
    );
}

export default Notification;